import {
    SET_USER_DATA_START,
    SET_USER_DATA_SUCCESS,
    SET_USER_DATA_ERROR
} from '../../constants';
import { userAccount as query } from '../../lib/graphql';

export function loadAccount() {
    return async (dispatch, getState, { client }) => {
        try {
            dispatch({
                type: SET_USER_DATA_START,
            });

            const { data } = await client.query({
                query,
                fetchPolicy: 'network-only'
            })

            if (data?.userAccount) {
                const profileData = data?.userAccount?.result;
                dispatch({
                    type: SET_USER_DATA_SUCCESS,
                    profileData
                });
            }
        } catch (error) {
            dispatch({
                type: SET_USER_DATA_ERROR,
                payload: {
                    error,
                },
            });
            return false;
        }
        return true;
    };
}
